import {
  boolean,
  object,
  type output,
  string,
} from 'zod';

export const MAX_MASTER_AWARD_TITLE_LENGTH = 250;

export const masterAwardRequestSchema = object({
  title: string().min(1, 'Enter a title.').max(MAX_MASTER_AWARD_TITLE_LENGTH, `Use ${MAX_MASTER_AWARD_TITLE_LENGTH} characters or fewer for the title.`),
  isActive: boolean('Select an active status.'),
});

export type MasterAwardRequest = output<typeof masterAwardRequestSchema>;
